import {
  JUMP_HIGHLIGHT_BORDER_RADIUS,
  JUMP_HIGHLIGHT_COLOR,
  JUMP_HIGHLIGHT_DURATION_MS,
} from '../constants/diffView.constants';

// Pass FlashList's row wrapper: the diff row's own container is ~0px tall on web
// (flex chain collapses it), so the overlay needs a taller anchor to paint on.
export const flashRowHighlight = (wrapper: HTMLElement): (() => void) => {
  const overlay = document.createElement('div');
  // `inset: 0` resolves against the nearest positioned ancestor, so if the
  // wrapper is `static` we'd paint against some scroller way up the tree.
  const computedPosition = window.getComputedStyle(wrapper).position;
  const shouldForcePosition = computedPosition === 'static' || computedPosition === '';
  const previousInlinePosition = wrapper.style.position;
  if (shouldForcePosition) {
    wrapper.style.position = 'relative';
  }
  Object.assign(overlay.style, {
    position: 'absolute',
    inset: '0',
    backgroundColor: JUMP_HIGHLIGHT_COLOR,
    pointerEvents: 'none',
    borderRadius: `${JUMP_HIGHLIGHT_BORDER_RADIUS}px`,
    mixBlendMode: 'multiply', // keeps text under the wash legible
  });
  wrapper.appendChild(overlay);

  let cleaned = false;
  const cleanup = () => {
    if (cleaned) {
      return;
    }
    cleaned = true;
    if (overlay.isConnected) {
      overlay.remove();
    }
    if (shouldForcePosition) {
      wrapper.style.position = previousInlinePosition;
    }
  };

  const animation = overlay.animate(
    [{ opacity: 1 }, { opacity: 0 }],
    { duration: JUMP_HIGHLIGHT_DURATION_MS, easing: 'ease-out' },
  );
  animation.addEventListener('finish', cleanup);
  animation.addEventListener('cancel', cleanup);

  return () => {
    try {
      animation.cancel();
    } catch {
      // Older WAAPI throws if cancel() runs after finish — cleanup handles it.
    }
    cleanup();
  };
};
